import { useGQL } from 'services/gql';
import { breakoutRoomSpeakerSchema } from './breakoutRoomSpeakerSchema';

const listBreakoutRoomSpeakersQuery = /* GraphQL */ `
    query listBreakoutRoomSpeakersQuery($id: ID!, $nextToken: String){
        getBreakoutRoom(id: $id){
            speakers(nextToken: $nextToken) {
                nextToken
                items {
                    ${breakoutRoomSpeakerSchema}
                }
            }            
        }
    }
`;

const createResultSchema = /* GraphQL */ `
  ${breakoutRoomSpeakerSchema}
`;

export const useBreakoutRoomSpeakerGql = () => {
  const {
    createMutation,
    createMultipleMutation,
    updateMutation,
    updateMultipleMutation,
    deleteMutation,
    deleteMultipleMutation,
    sendQuery,
  } = useGQL('breakoutRoomSpeaker');

  //QUERY
  const listBreakoutRoomSpeakers = (breakoutRoomId) =>
    sendQuery(
      'get-by-breakout-room',
      listBreakoutRoomSpeakersQuery,
      {
        id: breakoutRoomId,
      },
      true
    );

  //MUTATION
  const create = (input) => createMutation(input);
  const createMultiple = (inputList) => createMultipleMutation(inputList);
  const createAndFetchAllData = (input) =>
    createMutation(input, createResultSchema);
  const createMultipleAndFetchAllData = (inputList) =>
    createMultipleMutation(inputList, createResultSchema);
  const update = (input) => updateMutation(input);
  const updateMultiple = (inputList) => updateMultipleMutation(inputList);
  const remove = (input) => deleteMutation(input);
  const removeMultiple = (inputList) => deleteMultipleMutation(inputList);

  return {
    listBreakoutRoomSpeakers,
    create,
    createMultiple,
    createAndFetchAllData,
    createMultipleAndFetchAllData,
    update,
    updateMultiple,
    remove,
    removeMultiple,
  };
};
